import Image from "next/image";
import React from "react";
import { MdArrowOutward } from "react-icons/md";

const EbookCardData = [
    {
        imgSrc: "https://assets.gallabox.com/gb-home/ebook/whatsapp-for-marketing.png",
        label: "GUIDE",
        title: "Why (just) WhatsApp is Insufficient to Grow your Business ",
        link: "/resources/why-whatsapp-for-business-ebook",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/ebook/why-whatsapp-for-business.png",
        label: "EBOOK",
        title: "Hit your Marketing OKRs by Engaging Prospects on WhatsApp",
        link: "/resources/whatsapp-for-marketing-ebook",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/e-book/hero-image.png",
        label: "EBOOK",
        title: "The Complete Guide to WhatsApp for Real Estate Businesses",
        link: "/resources/whatsapp-for-real-estate-ebook",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/ebook/healthcare.png",
        label: "EBOOK",
        title: "How WhatsApp automation can shape up the future of better healthcare",
        link: "/resources/whatsapp-for-healthcare-ebook",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/ebook/ecommerce.png",
        label: "EBOOK",
        title: "Unlock More Sales: How E-commerce Brands Win on WhatsApp",
        link: "/resources/whatsapp-for-ecommerce-ebook",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/ebook/travel.png",
        label: "EBOOK",
        title: "Transform traveler experiences with WhatsApp automation",
        link: "/resources/whatsapp-for-travel-ebook",
    },

    {
        imgSrc: "https://assets.gallabox.com/gb-home/ebook/education.png",
        label: "EBOOK",
        title: "Faster Admissions, Better Engagement: The Complete Guide to WhatsApp for Educators",
        link: "/resources/whatsapp-for-education-ebook",
    },
    {
        imgSrc: "https://assets.gallabox.com/gb-home/ebook/support.png",
        label: "EBOOK",
        title: "Delight your customers by using WhatsApp automations for top-notch support",
        link: "/resources/whatsapp-for-support-ebook",
    },
];

const EbookCard: React.FC = () => {
    return (
        <section className="max-w-7xl mx-auto py-24">
            <h2 className="text-gray-900 text-4xl md:text-5xl font-semibold px-11 py-10">E-books</h2>
            <div className="grid md:grid-cols-3 grid-cols-1 px-5 gap-6">
                {EbookCardData.map((book, index) => (
                    <div key={index} className="bg-white md:shadow-md hover:shadow-2xl flex flex-col h-[500px] max-w-sm">
                        <Image width={399} height={250} style={{ objectFit: "cover", height: "250px", width: "100%" }} src={book.imgSrc} alt={book.title} />
                        <div className="flex flex-col justify-between flex-1 p-6 border border-gray-200">
                            <div>
                                <p className="text-gray-600 text-sm font-medium mb-2">{book.label}</p>
                                <p className="text-xl font-semibold text-black">{book.title}</p>
                            </div>
                            <button
                                className="mt-6 px-5 py-2 rounded bg-black text-white text-base font-medium flex items-center gap-2 w-fit"
                                onClick={() => window.open(book.link, "_blank")}
                            >
                                Read now <MdArrowOutward />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default EbookCard;
